import { render, staticRenderFns } from "./BillDetailForm.vue?vue&type=template&id=2e866e36&scoped=true"
import script from "./BillDetailForm.vue?vue&type=script&lang=js"
export * from "./BillDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e866e36",
  null
  
)

export default component.exports